// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabbar-container .van-tabbar{z-index:101;box-shadow:0 0 20px -10px #000}", ""]);
// Exports
module.exports = exports;
